import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import { fieldLabels } from '../profileUpdateFields';

// "Come back to it later" home for profile-update requests from the office
// (same data as the login popup). My Clients → Profile Updates.
function TherapistProfileUpdatesPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/therapist/profile-update-requests')
      .then((res) => setRequests(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.error('Error fetching profile update requests:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '1.5rem 1rem' }}>
      <h2 style={{ marginBottom: 4 }}>Profile Updates</h2>
      <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>
        Client information the office has asked you to fill in — usually a
        diagnosis code needed for an insurance invoice. Requests clear
        automatically once you save the requested fields on the client's profile.
      </p>

      {loading ? (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
          Loading…
        </div>
      ) : requests.length === 0 ? (
        <div style={emptyStyle}>
          <div style={{ fontSize: 34 }}>✅</div>
          <div style={{ fontWeight: 700 }}>All caught up</div>
          <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            No profile updates requested right now.
          </div>
        </div>
      ) : (
        requests.map((r) => (
          <div key={r.id} style={cardStyle}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{r.client_name}</div>
              <div style={{ fontSize: 14, margin: '2px 0' }}>
                Needs: <strong>{fieldLabels(r.requested_fields)}</strong>
              </div>
              {r.note && (
                <div style={{ fontSize: 13.5, color: 'var(--text-muted)', fontStyle: 'italic' }}>
                  “{r.note}”
                </div>
              )}
              <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 2 }}>
                Requested {new Date(r.created_at).toLocaleDateString()}
              </div>
            </div>
            <button
              onClick={() => navigate(`/therapist/client-profile?clientId=${r.client_id}`)}
              style={updateBtnStyle}
            >
              Update now
            </button>
          </div>
        ))
      )}
    </div>
  );
}

const cardStyle = {
  display: 'flex', gap: 12, alignItems: 'center',
  background: 'var(--white)', border: '1px solid var(--border-color)',
  borderRadius: 12, padding: '14px 16px', marginBottom: 10,
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const updateBtnStyle = {
  flexShrink: 0, background: 'var(--primary-color)', color: '#fff', border: 'none',
  borderRadius: 8, padding: '9px 14px', fontWeight: 700, cursor: 'pointer',
};
const emptyStyle = {
  textAlign: 'center', padding: '3rem 1rem',
  background: 'var(--white)', border: '1px solid var(--border-color)', borderRadius: 12,
};

export default TherapistProfileUpdatesPage;
